import { useState, } from "react";
import { Tabs, Button } from 'antd'
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./MaterialTableBox"
import { ItemTableBox } from "./ItemTableBox"
import { OtherItem } from "./OtherItem"
import { FixedBottom } from "./FixedBottom"
import { ImgBox } from './imgBox'
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useMaintenanceDetailsModel } from "../MaintenanceModel";

export const MaintenanceDetails = () => {
    const { getSelectedNavState, closeNav, selectedNavId } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { id } = detailsInfo

    const {
        itemDetailVisible,
        detailMaterialListVisible,
        otherItemDetailListVisible,
    } = useMaintenanceDetailsModel();

    //关闭当前页
    const onClose = () => {
        closeNav(selectedNavId);
    }

    return (
        <>
            <div style={{ float: 'right', position: 'relative', top: 7, right: 100, zIndex: 999 }}>
                <Button shape="round" onClick={onClose} >
                    返回
                </Button>
            </div>
            <Tabs defaultActiveKey="0" tabBarStyle={{ backgroundColor: 'white', paddingLeft: 10 }}>
                <Tabs.TabPane tab="工单信息" key="0">
                    <FormBox  {...detailsInfo} />
                    {itemDetailVisible && <ItemTableBox {...detailsInfo} />}
                    {detailMaterialListVisible && <MaterialTableBox {...detailsInfo} />}
                    {otherItemDetailListVisible && <OtherItem {...detailsInfo} />}
                    <br />
                    <br />
                    <br />
                    <br />
                    <FixedBottom {...detailsInfo} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="现场照片" key="1">
                    <ImgBox showOrderId={id} repairMode="team" />
                </Tabs.TabPane>
                <Tabs.TabPane tab="故障照片" key="2">
                    <ImgBox showOrderId={id} repairMode="customer" />
                </Tabs.TabPane>
            </Tabs>
        </>
    )
}